import { render, staticRenderFns } from "./GolfMembershipTransactionData.vue?vue&type=template&id=287d4d25&scoped=true&"
import script from "./GolfMembershipTransactionData.vue?vue&type=script&lang=js&"
export * from "./GolfMembershipTransactionData.vue?vue&type=script&lang=js&"
import style0 from "./GolfMembershipTransactionData.vue?vue&type=style&index=0&id=287d4d25&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287d4d25",
  null
  
)

export default component.exports